import { memo } from "react";
import IncreaseDecreaseBox from "../../../../../../Elements/IncreaseDecreaseBox/IncreaseDecreaseBox";
import useCurrency from "../../../../hooks/useCurrency";
import { CurrencySymbolE } from "../../../../models/enums";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import { useParams } from "react-router-dom";
import type { PackageTypeRouteT } from "../../../../models/models";
import useAddon from "../../../../hooks/useAddon";
import Image from "../../../../../../Elements/Image/Image";
import Tooltip from "../../../../../../Elements/Tooltip/Tooltip";
import {
  MAX_EXTRA_STORAGE_DEFAULT_VALUE_IN_TB,
  MAX_SUB_USERS_DEFAULT_VALUE,
} from "../../helpers/constants";
import { useUser } from "../../../../../../../contexts/userContext/userContext";

import styles from "./styles.module.scss";

const NewAddonPrice = memo(() => {
  const { packageType } = useParams<{
    packageType: PackageTypeRouteT;
  }>();
  const { currency } = useCurrency();
  const { getTextByKey } = useContent();
  const { addonData, addonQuantity, setAddonQuantity, existingAddonQuantity } =
    useAddon();
  const { getUserData } = useUser();

  const maxSubUsers = getUserData()?.MaxSubUsers || MAX_SUB_USERS_DEFAULT_VALUE;

  return (
    <>
      <div className={styles.sideContainer}>
        <div className={styles.textContainer}>
          <div className={styles.title}>{getTextByKey("new-quanity")}</div>
          <div className={styles.subTitle}>
            {CurrencySymbolE[currency]}
            {addonData?.[currency]} {getTextByKey(`price-per-${packageType}`)}
          </div>
          <div className={styles.subTitle}>
            {getTextByKey("monthly-cost")}{" "}
            {addonData?.[currency]! * addonQuantity}
            {CurrencySymbolE[currency]}
          </div>
        </div>
      </div>
      <div className={styles.licenseSelectorWrapper}>
        <IncreaseDecreaseBox
          value={addonQuantity}
          setValue={setAddonQuantity}
          // Not allow to do downgrade if current quantity is already zero
          minValue={existingAddonQuantity > 0 ? 0 : 1}
          maxValue={
            packageType === "sub-users"
              ? maxSubUsers
              : MAX_EXTRA_STORAGE_DEFAULT_VALUE_IN_TB
          }
        />
        {+addonQuantity ===
        +(packageType === "sub-users"
          ? maxSubUsers
          : MAX_EXTRA_STORAGE_DEFAULT_VALUE_IN_TB) ? (
          <div className={styles.limitExceededIcon}>
            {/*@ts-ignore*/}
            <Tooltip
              id="sub-users-max-limit"
              tooltipTextKey={`${packageType}-limit-can-not-be-exceed`}
              top
            >
              <Image name="create-form/exclamation-icon" title="" />
            </Tooltip>
          </div>
        ) : null}
      </div>
    </>
  );
});

export default NewAddonPrice;
